export const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:4080/api';
export const APP_NAME = process.env.REACT_APP_NAME || 'ALKAYOL';
export const APP_VERSION = process.env.REACT_APP_VERSION || '1.0.0';

// Layout settings
export const layoutTypes = {
  HORIZONTAL: 'horizontal',
  VERTICAL: 'vertical',
};

export const layoutModeTypes = {
  LIGHTMODE: 'light',
  DARKMODE: 'dark',
};

export const layoutWidthTypes = {
  FLUID: 'fluid',
  BOXED: 'boxed',
};

export const layoutPositionTypes = {
  FIXED: 'fixed',
  SCROLLABLE: 'scrollable',
};

export const topbarThemeTypes = {
  LIGHT: 'light',
  DARK: 'dark',
};

export const sidebarSizeTypes = {
  DEFAULT: 'lg',
  COMPACT: 'md',
  SMALL: 'sm',
};

export const sidebarVisibilityTypes = {
  SHOW: 'show',
  HIDDEN: 'hidden',
};
